export default __webpack_public_path__ + "static/media/ico_tv_tower.bac6650f.svg";